{
  "format": "Tyche event contract registry v1 (not itself JSON Schema; definitions use JSON Schema keywords)",
  "status": "IMPLEMENTING_NOT_INSTALLED",
  "baseline_commit": "40b80e56703d18374699aeafd82ca7c854b566d5",
  "precedence": "Event field lists/types in this registry; lifecycle and semantic rules in implementation plan; acceptance matrix validates both.",
  "validation_rules": [
    "An event is {event: name, ...commonRequired, ...allowedEventFields}; reject unknown keys.",
    "Required means key must be present. Nullable overrides allow null, not absent.",
    "Optional fields are OMITTED when unknown. Never substitute 0, empty string or fake identifiers.",
    "Pixel owns distinct_id, event_source, consent_basis, shop_domain, taxonomy_version. Ignore attempted overrides in customData.",
    "Money is major-unit numeric with ISO currency; malformed/missing amount and its currency are omitted as a pair.",
    "No raw checkout/cart token, full query URL, user/customer PII, raw error message or raw Shopify event is allowed.",
    "Apply property_overrides after shared definitions. Apply conditional_required when its when clause matches.",
    "Nonempty strings only. Finite numbers only. All timestamps must parse as UTC instants.",
    "Money pairing is per event: value/currency or shipping_value/currency; required money invalidates ledger event.",
    "Theme transport omits pixel-owned distinct_id and consent_basis; final envelope must contain all common_required."
  ],
  "common_required": [
    "event_id",
    "distinct_id",
    "occurred_at",
    "taxonomy_version",
    "event_domain",
    "event_source",
    "environment",
    "traffic_type",
    "release_id",
    "shop_domain",
    "consent_basis"
  ],
  "common_optional": [
    "replay_session_id",
    "replay_url",
    "replay_status"
  ],
  "definitions": {
    "event_id": {
      "type": "string",
      "maxLength": 256,
      "minLength": 1
    },
    "distinct_id": {
      "type": "string",
      "maxLength": 200,
      "minLength": 1
    },
    "occurred_at": {
      "type": "string",
      "maxLength": 128,
      "format": "date-time",
      "minLength": 1
    },
    "release_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "shop_domain": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "taxonomy_version": {
      "type": "integer",
      "const": 1
    },
    "consent_basis": {
      "type": "string",
      "const": "shopify_analytics_allowed",
      "minLength": 1
    },
    "event_domain": {
      "type": "string",
      "enum": [
        "commerce"
      ],
      "minLength": 1
    },
    "event_source": {
      "type": "string",
      "enum": [
        "theme_custom",
        "shopify_pixel",
        "shopify_ledger"
      ],
      "minLength": 1
    },
    "environment": {
      "type": "string",
      "enum": [
        "production",
        "preview",
        "local"
      ],
      "minLength": 1
    },
    "traffic_type": {
      "type": "string",
      "enum": [
        "external",
        "internal",
        "test"
      ],
      "minLength": 1
    },
    "page_instance_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "search_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "result_set_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "operation_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "filter_change_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "filter_apply_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "submission_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "cart_view_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "exposure_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "product_id": {
      "type": "string",
      "maxLength": 128,
      "description": "Canonical Shopify GID string; null only when event-specific nullable override is stated in the plan.",
      "minLength": 1
    },
    "variant_id": {
      "type": "string",
      "maxLength": 128,
      "description": "Canonical Shopify GID string; null only when event-specific nullable override is stated in the plan.",
      "minLength": 1
    },
    "order_id": {
      "type": "string",
      "maxLength": 128,
      "description": "Canonical Shopify GID string; null only when event-specific nullable override is stated in the plan.",
      "minLength": 1
    },
    "transaction_id": {
      "type": "string",
      "maxLength": 128,
      "description": "Canonical Shopify GID string; null only when event-specific nullable override is stated in the plan.",
      "minLength": 1
    },
    "refund_id": {
      "type": "string",
      "maxLength": 128,
      "description": "Canonical Shopify GID string; null only when event-specific nullable override is stated in the plan.",
      "minLength": 1
    },
    "sku": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "part_number_normalized": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "product_vendor": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "vehicle_brand": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "part_type": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "condition": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "media_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "recommendation_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "page_path": {
      "type": "string",
      "maxLength": 256,
      "minLength": 1
    },
    "referrer_host": {
      "type": "string",
      "maxLength": 253,
      "minLength": 1
    },
    "landing_source": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1,
      "enum": [
        "direct",
        "search_engine",
        "social",
        "referral",
        "internal",
        "unknown"
      ]
    },
    "query_normalized": {
      "type": "string",
      "maxLength": 80,
      "minLength": 1
    },
    "query_redacted": {
      "type": "boolean"
    },
    "page_type": {
      "type": "string",
      "enum": [
        "home",
        "search",
        "product",
        "cart",
        "contact",
        "content",
        "account",
        "careers",
        "other"
      ],
      "minLength": 1
    },
    "search_method": {
      "type": "string",
      "enum": [
        "text",
        "vehicle_filters",
        "mixed"
      ],
      "minLength": 1
    },
    "query_type": {
      "type": "string",
      "enum": [
        "part_number",
        "brand",
        "keyword",
        "empty",
        "unknown"
      ],
      "minLength": 1
    },
    "entry_point": {
      "type": "string",
      "enum": [
        "home_vehicle",
        "desktop_search",
        "mobile_search",
        "header",
        "product_page",
        "quick_add",
        "bulk_quick_add",
        "quick_order_list",
        "cart_page",
        "cart_drawer",
        "other"
      ],
      "minLength": 1
    },
    "surface": {
      "type": "string",
      "enum": [
        "desktop_home",
        "mobile_home",
        "desktop_sidebar",
        "mobile_sidebar",
        "search_bar"
      ],
      "minLength": 1
    },
    "filter_name": {
      "type": "string",
      "enum": [
        "part_type",
        "vehicle_brand",
        "vehicle_model",
        "placement",
        "condition",
        "availability",
        "price",
        "other"
      ],
      "minLength": 1
    },
    "previous_values": {
      "type": "array",
      "maxItems": 20,
      "items": {
        "type": "string",
        "maxLength": 128
      },
      "uniqueItems": true
    },
    "new_values": {
      "type": "array",
      "maxItems": 20,
      "items": {
        "type": "string",
        "maxLength": 128
      },
      "uniqueItems": true
    },
    "change_reason": {
      "type": "string",
      "enum": [
        "user",
        "dependency_reset"
      ],
      "minLength": 1
    },
    "apply_method": {
      "type": "string",
      "enum": [
        "search_button",
        "auto_apply",
        "sidebar_apply",
        "reset"
      ],
      "minLength": 1
    },
    "results_scope": {
      "type": "string",
      "enum": [
        "products",
        "mixed",
        "unknown"
      ],
      "minLength": 1
    },
    "result_origin": {
      "type": "string",
      "enum": [
        "user_search",
        "filter_change",
        "sort",
        "pagination",
        "history",
        "direct",
        "collection_redirect",
        "auto_normalization"
      ],
      "minLength": 1
    },
    "results_count": {
      "type": "integer",
      "minimum": 0
    },
    "rendered_product_count": {
      "type": "integer",
      "minimum": 0
    },
    "page_number": {
      "type": "integer",
      "minimum": 1
    },
    "position": {
      "type": "integer",
      "minimum": 1
    },
    "item_count": {
      "type": "integer",
      "minimum": 0
    },
    "quantity": {
      "type": "integer",
      "minimum": 0
    },
    "added_quantity": {
      "type": "integer",
      "minimum": 1
    },
    "previous_quantity": {
      "type": "integer",
      "minimum": 0
    },
    "load_ms": {
      "type": "number",
      "minimum": 0
    },
    "value": {
      "type": "number",
      "minimum": 0
    },
    "shipping_value": {
      "type": "number",
      "minimum": 0
    },
    "currency": {
      "type": "string",
      "maxLength": 3,
      "pattern": "^[A-Z]{3}$",
      "minLength": 1
    },
    "sort_key": {
      "type": "string",
      "maxLength": 48,
      "minLength": 1
    },
    "list_type": {
      "type": "string",
      "enum": [
        "search",
        "recommendation",
        "featured",
        "collection"
      ],
      "minLength": 1
    },
    "source_list_type": {
      "type": "string",
      "enum": [
        "search",
        "recommendation",
        "featured",
        "collection",
        "direct",
        "unknown"
      ],
      "minLength": 1
    },
    "navigation_mode": {
      "type": "string",
      "enum": [
        "same_tab",
        "new_context"
      ],
      "minLength": 1
    },
    "availability": {
      "type": "string",
      "enum": [
        "available",
        "sold_out",
        "unknown"
      ],
      "minLength": 1
    },
    "action": {
      "type": "string",
      "enum": [
        "add",
        "change",
        "remove",
        "clear"
      ],
      "minLength": 1
    },
    "failure_stage": {
      "type": "string",
      "enum": [
        "mutation",
        "transport",
        "response_parse",
        "render",
        "refresh"
      ],
      "minLength": 1
    },
    "error_code": {
      "type": "string",
      "enum": [
        "out_of_stock",
        "quantity_limit",
        "validation",
        "http_error",
        "network_error",
        "response_parse_error",
        "api_unavailable",
        "unknown"
      ],
      "minLength": 1
    },
    "http_status": {
      "type": "integer",
      "minimum": 0,
      "maximum": 599
    },
    "cart_surface": {
      "type": "string",
      "enum": [
        "page",
        "drawer",
        "notification"
      ],
      "minLength": 1
    },
    "checkout_key": {
      "type": "string",
      "maxLength": 64,
      "description": "SHA-256 hex of shop_domain + \"|\" + checkout.token; null if unavailable. Never send the token.",
      "minLength": 1,
      "pattern": "^[a-f0-9]{64}$"
    },
    "shipping_method_code": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1
    },
    "is_test": {
      "type": "boolean"
    },
    "form_id": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1
    },
    "placement": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1,
      "enum": [
        "home_grid",
        "collection_grid",
        "search_grid",
        "pdp_recommendations",
        "pdp_policy",
        "cart_drawer",
        "footer",
        "newsletter_popup",
        "contact_page",
        "other"
      ]
    },
    "detail_type": {
      "type": "string",
      "enum": [
        "shipping",
        "returns",
        "quality",
        "packaging",
        "eligibility",
        "exclusions",
        "before_purchase",
        "specifications",
        "other"
      ],
      "minLength": 1
    },
    "media_action": {
      "type": "string",
      "enum": [
        "select",
        "zoom_open",
        "video_play"
      ],
      "minLength": 1
    },
    "contact_channel": {
      "type": "string",
      "enum": [
        "contact_page",
        "email",
        "phone",
        "chat",
        "external"
      ],
      "minLength": 1
    },
    "operation_name": {
      "type": "string",
      "enum": [
        "filter_options_load",
        "recommendation_load",
        "cart_render",
        "cart_refresh"
      ],
      "minLength": 1
    },
    "experiment_key": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1
    },
    "variant_key": {
      "type": "string",
      "maxLength": 64,
      "minLength": 1
    },
    "transaction_kind": {
      "type": "string",
      "enum": [
        "SALE",
        "CAPTURE",
        "REFUND"
      ],
      "minLength": 1
    },
    "attribution_status": {
      "type": "string",
      "enum": [
        "matched"
      ],
      "minLength": 1
    },
    "is_backfill": {
      "type": "boolean"
    },
    "active_filters": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "part_type": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "vehicle_brand": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "vehicle_model": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "placement": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "condition": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "availability": {
          "type": "array",
          "maxItems": 20,
          "uniqueItems": true,
          "items": {
            "type": "string",
            "maxLength": 128
          }
        },
        "price_min": {
          "type": [
            "number",
            "null"
          ],
          "minimum": 0
        },
        "price_max": {
          "type": [
            "number",
            "null"
          ],
          "minimum": 0
        }
      }
    },
    "price_context": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "price_source",
        "catalog_price",
        "displayed_price",
        "currency"
      ],
      "properties": {
        "price_source": {
          "type": "string",
          "enum": [
            "liquid",
            "ajax_cart",
            "unknown"
          ]
        },
        "catalog_price": {
          "type": [
            "number",
            "null"
          ],
          "minimum": 0
        },
        "displayed_price": {
          "type": [
            "number",
            "null"
          ],
          "minimum": 0
        },
        "currency": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^[A-Z]{3}$"
        },
        "display_currency": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^[A-Z]{3}$"
        },
        "display_discount_percent": {
          "type": [
            "number",
            "null"
          ],
          "minimum": 0,
          "maximum": 100
        },
        "pricing_mismatch": {
          "type": "boolean"
        }
      }
    },
    "replay_session_id": {
      "type": "string",
      "maxLength": 128,
      "minLength": 1
    },
    "replay_url": {
      "type": "string",
      "maxLength": 512,
      "description": "Only us.posthog.com/project/639039/replay/... obtained from SDK; omit if unavailable. Test project URL substituted in dev store.",
      "minLength": 1
    },
    "replay_status": {
      "type": "string",
      "enum": [
        "available",
        "unavailable"
      ],
      "minLength": 1
    }
  },
  "events": [
    {
      "name": "storefront_page_viewed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "final page rendered",
      "required": [
        "page_type",
        "page_path",
        "page_instance_id"
      ],
      "optional": [
        "landing_source",
        "referrer_host"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "search_submitted",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "explicit user search submit",
      "required": [
        "search_id",
        "search_method",
        "query_type",
        "entry_point",
        "page_instance_id"
      ],
      "optional": [
        "query_normalized",
        "query_redacted",
        "active_filters"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "search_results_viewed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "active result container committed",
      "required": [
        "result_set_id",
        "page_instance_id",
        "results_count",
        "rendered_product_count",
        "results_scope",
        "result_origin",
        "page_number",
        "sort_key"
      ],
      "optional": [
        "search_id",
        "active_filters",
        "load_ms"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "filter_changed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "trusted filter control change",
      "required": [
        "filter_change_id",
        "filter_name",
        "previous_values",
        "new_values",
        "change_reason",
        "surface",
        "page_instance_id"
      ],
      "optional": [
        "search_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "filter_applied",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "pending filter navigation matched committed results",
      "required": [
        "filter_apply_id",
        "result_set_id",
        "active_filters",
        "results_count",
        "apply_method",
        "page_instance_id",
        "surface",
        "results_scope"
      ],
      "optional": [
        "search_id",
        "rendered_product_count"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "product_selected",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "actual product link activation",
      "required": [
        "product_id",
        "list_type",
        "position",
        "page_instance_id",
        "navigation_mode",
        "placement"
      ],
      "optional": [
        "variant_id",
        "sku",
        "result_set_id",
        "search_id",
        "recommendation_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan",
      "conditional_required": [
        {
          "when": {
            "list_type": "search"
          },
          "fields": [
            "result_set_id"
          ]
        },
        {
          "when": {
            "list_type": "recommendation"
          },
          "fields": [
            "recommendation_id"
          ]
        }
      ]
    },
    {
      "name": "product_viewed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "primary product context and visible main content ready",
      "required": [
        "product_id",
        "page_instance_id",
        "availability",
        "price_context"
      ],
      "optional": [
        "variant_id",
        "sku",
        "part_number_normalized",
        "product_vendor",
        "vehicle_brand",
        "part_type",
        "condition",
        "source_list_type",
        "result_set_id",
        "search_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "cart_add_requested",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "validated add request sent",
      "required": [
        "operation_id",
        "variant_id",
        "quantity",
        "entry_point",
        "page_instance_id"
      ],
      "optional": [
        "product_id",
        "sku"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan",
      "property_overrides": {
        "quantity": {
          "minimum": 1
        }
      }
    },
    {
      "name": "product_added_to_cart",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "valid Shopify add response before later UI refresh",
      "required": [
        "operation_id",
        "variant_id",
        "quantity",
        "added_quantity",
        "price_context",
        "entry_point",
        "page_instance_id"
      ],
      "optional": [
        "product_id",
        "sku",
        "value",
        "currency"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan",
      "property_overrides": {
        "quantity": {
          "minimum": 1
        }
      }
    },
    {
      "name": "cart_action_failed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "cart mutation rejected or transport/parse failure",
      "required": [
        "operation_id",
        "action",
        "failure_stage",
        "error_code",
        "page_instance_id"
      ],
      "optional": [
        "http_status",
        "variant_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "cart_viewed",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "visible cart page/drawer opening with cart state",
      "required": [
        "cart_view_id",
        "cart_surface",
        "item_count",
        "page_instance_id"
      ],
      "optional": [
        "value",
        "currency"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "checkout_started",
      "phase": "P0",
      "source": "shopify_pixel",
      "trigger_summary": "Shopify checkout_started subscription",
      "required": [
        "checkout_key",
        "item_count"
      ],
      "optional": [
        "value",
        "currency"
      ],
      "nullable_overrides": [
        "checkout_key"
      ],
      "deduplication": "shop_domain + Shopify event.id"
    },
    {
      "name": "checkout_shipping_info_submitted",
      "phase": "P0",
      "source": "shopify_pixel",
      "trigger_summary": "Shopify shipping subscription",
      "required": [
        "checkout_key"
      ],
      "optional": [
        "shipping_method_code",
        "shipping_value",
        "currency"
      ],
      "nullable_overrides": [
        "checkout_key"
      ],
      "deduplication": "shop_domain + Shopify event.id"
    },
    {
      "name": "payment_info_submitted",
      "phase": "P0",
      "source": "shopify_pixel",
      "trigger_summary": "Shopify payment info subscription",
      "required": [
        "checkout_key"
      ],
      "optional": [
        "value",
        "currency"
      ],
      "nullable_overrides": [
        "checkout_key"
      ],
      "deduplication": "shop_domain + Shopify event.id"
    },
    {
      "name": "shopify_checkout_completed",
      "phase": "P0",
      "source": "shopify_pixel",
      "trigger_summary": "Shopify checkout_completed subscription",
      "required": [
        "checkout_key",
        "order_id",
        "item_count"
      ],
      "optional": [
        "value",
        "currency",
        "is_test"
      ],
      "nullable_overrides": [
        "checkout_key",
        "order_id"
      ],
      "deduplication": "shop_domain + Shopify event.id"
    },
    {
      "name": "inquiry_submitted",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "Shopify contact posted_successfully with pending submission",
      "required": [
        "form_id",
        "submission_id",
        "page_instance_id"
      ],
      "optional": [
        "product_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "newsletter_request_sent",
      "phase": "P0",
      "source": "theme_custom",
      "trigger_summary": "EmailJS sendForm resolved",
      "required": [
        "form_id",
        "submission_id",
        "placement",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "product_detail_viewed",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "static policy heading visible 50 percent for 1000 ms",
      "required": [
        "product_id",
        "detail_type",
        "exposure_id",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "product_detail_opened",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "real details/accordion transitions closed to open",
      "required": [
        "product_id",
        "detail_type",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "product_list_item_viewed",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "visible card 50 percent for 1000 ms",
      "required": [
        "product_id",
        "list_type",
        "position",
        "exposure_id",
        "page_instance_id",
        "placement"
      ],
      "optional": [
        "result_set_id",
        "search_id",
        "recommendation_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan",
      "conditional_required": [
        {
          "when": {
            "list_type": "search"
          },
          "fields": [
            "result_set_id"
          ]
        },
        {
          "when": {
            "list_type": "recommendation"
          },
          "fields": [
            "recommendation_id"
          ]
        }
      ]
    },
    {
      "name": "product_media_interacted",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "user selects image or opens zoom",
      "required": [
        "product_id",
        "media_id",
        "media_action",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "cart_updated",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "non-add mutation success with before and after snapshot",
      "required": [
        "operation_id",
        "action",
        "item_count",
        "page_instance_id"
      ],
      "optional": [
        "value",
        "currency",
        "variant_id",
        "previous_quantity",
        "quantity"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "contact_cta_clicked",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "verified contact link activation",
      "required": [
        "contact_channel",
        "placement",
        "page_instance_id"
      ],
      "optional": [
        "product_id"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "ui_request_failed",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "failed filter/recommendation/cart-render request",
      "required": [
        "operation_id",
        "operation_name",
        "failure_stage",
        "error_code",
        "page_instance_id"
      ],
      "optional": [
        "http_status"
      ],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "form_submission_failed",
      "phase": "P1",
      "source": "theme_custom",
      "trigger_summary": "submission rejection or transport error",
      "required": [
        "submission_id",
        "form_id",
        "error_code",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan"
    },
    {
      "name": "experiment_exposed",
      "phase": "P2",
      "source": "theme_custom",
      "trigger_summary": "flag-dependent component visible",
      "required": [
        "experiment_key",
        "variant_key",
        "exposure_id",
        "page_instance_id"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "application event_id; semantic dedup rules in plan",
      "purpose": "Only once feature variant is visible; native Experiments remains gated by verified exposure identity."
    },
    {
      "name": "payment_captured",
      "phase": "P2",
      "source": "shopify_ledger",
      "trigger_summary": "new successful SALE or CAPTURE with validated order mapping",
      "required": [
        "order_id",
        "transaction_id",
        "transaction_kind",
        "value",
        "currency",
        "attribution_status",
        "is_backfill",
        "is_test"
      ],
      "optional": [],
      "nullable_overrides": [],
      "deduplication": "shop_domain + transaction_id + transaction_kind",
      "property_overrides": {
        "transaction_kind": {
          "enum": [
            "SALE",
            "CAPTURE"
          ]
        },
        "value": {
          "exclusiveMinimum": 0
        },
        "is_backfill": {
          "const": false
        }
      }
    },
    {
      "name": "refund_completed",
      "phase": "P2",
      "source": "shopify_ledger",
      "trigger_summary": "new successful REFUND transaction with validated order mapping",
      "required": [
        "order_id",
        "transaction_id",
        "transaction_kind",
        "value",
        "currency",
        "attribution_status",
        "is_backfill",
        "is_test"
      ],
      "optional": [
        "refund_id"
      ],
      "nullable_overrides": [],
      "deduplication": "shop_domain + transaction_id + transaction_kind",
      "property_overrides": {
        "transaction_kind": {
          "enum": [
            "REFUND"
          ]
        },
        "value": {
          "exclusiveMinimum": 0
        },
        "is_backfill": {
          "const": false
        }
      }
    }
  ]
}
